function isOnScreen(s) {
    if (s.length != 0) {
        var e = jQuery(window),
            t = e.scrollTop(),
            o = e.height(),
            l = t + o,
            n = jQuery(s),
            i = n.offset().top,
            r = n.height(),
            a = i + r;
        return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
    }
}

document.addEventListener("DOMContentLoaded", function () {

    isOnScreen($(".non-sticky-atc-button").eq(0))
        ? $(".sticky-atc-button").fadeOut(100)
        : $(".sticky-atc-button").fadeIn(100),
        $(window).on("scroll", function () {
            isOnScreen($(".non-sticky-atc-button").eq(0))
                ? $(".sticky-atc-button").fadeOut(10)
                : $(".sticky-atc-button").fadeIn(10);
        })

    const fadeElements = document.querySelectorAll('.fade-in-animation');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const delay = element.getAttribute('data-delay') || 0.4;
                setTimeout(() => {
                    element.classList.add('visible');
                }, delay);
                observer.unobserve(element);
            }
        });
    }, {
        threshold: 0.1
    });

    fadeElements.forEach(element => {
        observer.observe(element);
    });


    // Custom Dropdown Start
    if ($('.js-summary').length > 0) {
        $('.js-summary').click(function () {
            var detailsBody = $(this).next('.js-details-body');
            // $('.js-summary').removeClass("active");
            $(this).toggleClass("active");

            // Slide toggle the body
            detailsBody.slideToggle();
        });
    }
    // Custom Dropdown End



    // Set --announcement-bar-height Variable Start
    const announcementBar = document.querySelector('.main-header__announcement-bar');

    function setAnnouncementBarHeight() {
        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
    }

    function handleScroll() {
        const scrollTop = window.scrollY;

        const announcementBarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'));

        if (scrollTop > announcementBarHeight) {
            document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        } else {
            setAnnouncementBarHeight();
        }
    }

    setAnnouncementBarHeight();

    window.addEventListener('scroll', handleScroll);

    // Set --announcement-bar-height Variable End

    // Get all items with the class 'departaments__items'
    document.querySelectorAll('.departaments__items').forEach(function (item) {
        // When hovering over an item
        item.addEventListener('mouseenter', function () {
            // Change color of all other items
            document.querySelectorAll('.departaments__items').forEach(function (sibling) {
                if (sibling !== item) {
                    sibling.querySelector(".departaments__items-link").style.opacity = '0.5'; // Change color for all other items
                }
            });
        });

        // When mouse leaves the item
        item.addEventListener('mouseleave', function () {
            // Reset color of all items
            document.querySelectorAll('.departaments__items').forEach(function (sibling) {
                sibling.querySelector(".departaments__items-link").style.opacity = ''; // Reset color to original
            });
        });
    });


    // Set --search-bar-from-left start
    function searchXPosition() {
        const searchElement = document.querySelector('.fast-search-bar');
        const searchEect = searchElement.getBoundingClientRect();
        const searchXPosition = searchEect.left; // Horizontal distance from the left side of the viewport

        document.documentElement.style.setProperty('--search-bar-from-left', `${searchXPosition}px`);
    }

    searchXPosition()

    window.addEventListener('resize', searchXPosition);
    // Set --search-bar-from-left end



    // Collections USP start
    if ($('.js-sp-usp-2-marquee').length > 0) {
        $('.js-sp-usp-2-marquee').slick({
            speed: 8000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            slidesToScroll: 1,
            variableWidth: true,
            dots: false,
            arrows: false
        });
    }
    // Collections USP start

    let load_more_btn = document.getElementById("load-more-collections-btn");
    if (load_more_btn) {
        collectionAjax(load_more_btn)
    }
    let load_previous_btn = document.getElementById("load-previous-collections-btn");
    if (load_previous_btn) {
        collectionAjax(load_previous_btn)
    }
    if ($(".js-sp-product-card-key-title").length > 0) {
        $(".js-sp-product-card-key-title").click(function () {
            $(this).toggleClass("is-active");
            $(this).next('.js-sp-product-card-key-list').slideToggle();
        })
    }
    // Product card key toggle End

    // AD content read more toggle Start
    if ($(".js-sp-content-more-title").length > 0 && $(".js-sp-content-more-body").length > 0) {
        let titlePositionfromDoc = 0;
        $(".js-sp-content-more-title").click(function (e) {
            let $this = $(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active');
                $(this).find(".sp-title").text("Read more");
                $('html, body').animate({
                    scrollTop: titlePositionfromDoc
                }, 500);
            } else {
                titlePositionfromDoc = $(window).scrollTop();
                $this.addClass('active');
                $this.find(".sp-title").text("Show less");
            }
            $this.toggleClass("is-active");
            $this.closest(".sp-content").find('.js-sp-content-more-body').slideToggle("slow");
        });
    }
    // AD content read more toggle end    

    // PDP Add On product slider start
    if ($('.js-sp-product-add-on-slider').length > 0) {
        $('.js-sp-product-add-on-slider').slick({
            slidesToShow: 3.85,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            prevArrow: `<button type="button" class="slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.5,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }
    // PDP Add On product slider end

    /* scroll to target */
    jQuery('.scrollTo').click(function (e) {
        let jump = '#' + jQuery(this).data('anchor');
        let new_position = jQuery(jump).offset();
        let scroll = 0;
        let header_height = jQuery('header.header').height();
        if (jQuery('.sp-product-nav-shopify-section').hasClass('sticky')) {
            header_height = jQuery('.sp-product-nav-shopify-section').height();
        }

        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll - header_height }, 800, function () {
            let new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll - header_height }, 800);

        });
        e.preventDefault();
    });

    const sections = document.querySelectorAll(".section-to-track");
    const navLinks = document.querySelectorAll(".sp-product-nav__list-item");
    const navBarLinks = document.querySelector('.sp-product-nav');
    if (document.body.classList.contains('sp-product-page') && navLinks.length > 0) {
        // Function to determine the active section
        const setActiveLink = () => {
            let activeSectionFound = false;

            // Loop through all sections to find the one in view
            sections.forEach((section, index) => {
                const rect = section.getBoundingClientRect();
                // Check if the section is in the viewport
                if (rect.top <= 150 && rect.bottom >= 150) {
                    // Remove active class from all links
                    navLinks.forEach((link) => {
                        if (section.id !== link.dataset.anchor) {
                            link.classList.remove("active")
                        } else {
                            link.classList.add("active");
                            activeSectionFound = true;
                            scrollToActiveNavItem(link);
                        }
                    });
                }
            });

            // If no section is in view, remove the active class from all links
            let navbarVisible = true;
            if (navBarLinks) {
                navbarVisible = false
                const rectNav = navBarLinks.getBoundingClientRect();
                if (rectNav.top <= 150 && rectNav.bottom >= 150) {
                    navbarVisible = true
                }
            }

            if (!activeSectionFound && navbarVisible) {
                navLinks.forEach((link) => link.classList.remove("active"));
            }
        };
        // Function to scroll the active nav item into view
        const scrollToActiveNavItem = (activeItem) => {
            const navList = document.querySelector(".sp-product-nav__list");
            if (navList && activeItem) {
                navList.scrollTo({
                    left: activeItem.offsetLeft - navList.offsetWidth / 2 + activeItem.offsetWidth / 2,
                    behavior: "smooth"
                });
            }
        };
        // Debounced version of setActiveLink
        const debouncedSetActiveLink = debounce(setActiveLink, 100); // 100ms delay

        // Attach scroll event listener with debouncing
        window.addEventListener("scroll", debouncedSetActiveLink);

        // Initialize on page load
        setActiveLink();
    }
    // Accordion start
    if ($('.js-accordion-list').length > 0) {
        $('.js-accordion-list').each(function () {
            $(this).find('.js-accordion-list-item-body').hide();
        });
        $('.js-accordion-list .js-accordion-list-item-header').click(function (e) {
            let $parentItem = $(this).parent('.js-accordion-list-item');
            let $accordionList = $(this).closest('.js-accordion-list');
            $accordionList.find('.js-accordion-list-item')
                .not($parentItem)
                .removeClass('is--active')
                .find('.js-accordion-list-item-body')
                .slideUp();
            if ($parentItem.hasClass('is--active')) {
                $parentItem.removeClass('is--active').find('.js-accordion-list-item-body').slideUp();
            } else {
                $parentItem.addClass('is--active').find('.js-accordion-list-item-body').slideDown();
            }
            return false;
        });
    }
    // Accordion end

    // AD Product Video slider Start
    function playVideo(element) {
        let videoContainer = element.closest(".js-sp-video-main-video");
        videoContainer.classList.add("is--active");

        let video = videoContainer.querySelector("video");
        video.play();

        // Remove any existing volumechange listener before adding a new one
        video.removeEventListener("volumechange", muteHandler);
        video.addEventListener("volumechange", muteHandler);
    }

    // Define the mute handler function separately
    function muteHandler(event) {
        event.target.muted = true;
    }

    function pauseVideo(element) {
        element.closest(".js-sp-video-main-video").classList.remove("is--active")
        element.closest(".js-sp-video-main-video").querySelector("video").pause();
    }

    let $slider = $('.js-sp-video-main-slider');
    let $progressBar = $('.js-sp-video-slider-progressbar');
    let $progressBarLabel = $('.js-sp-video-slider-progressbar-label');

    if ($slider.length > 0) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.js-sp-video-nav-slider',
            infinite: false
        })
        $('.js-sp-video-nav-slider').slick({
            // dots: true,
            infinite: false,
            asNavFor: '.js-sp-video-main-slider',
            slidesToShow: 5.6,
            slidesToScroll: 1,
            focusOnSelect: true,
            prevArrow: `<button type="button" class="sp-slick-arrow sp-slick-prev slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="sp-slick-arrow sp-slick-next slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: false
                    }
                }
            ]
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });
        $slider.on('afterChange', function (event, slick, currentSlide) {
            const mainSlides = document.querySelectorAll(".sp-video__main-slide");
            mainSlides.forEach(function (element, index) {
                if (currentSlide === index) {
                    playVideo(element.querySelector(".js-sp-video-main-video-btn"));
                }
                if (currentSlide !== index && element.querySelector(".js-sp-video-main-video").classList.contains("is--active")) {
                    pauseVideo(element.querySelector(".js-sp-video-main-video-btn"));
                }
            })
        });
        // AD Product Video slider End

        // AD Product Video Play Pause Start
        const videoBtn = document.querySelectorAll(".js-sp-video-main-video-btn");
        videoBtn.forEach(function (btn) {
            btn.addEventListener("click", function () {
                playVideo(this);
            })
        })
        // Get all video elements in the slider
        const advideos = document.querySelectorAll('.sp-video__main-slider video');

        // Add an 'ended' event listener to each video
        advideos.forEach((video) => {
            video.addEventListener('ended', function () {
                // Get the current slide index
                const currentSlide = $slider.slick('slickCurrentSlide');

                // Check if the current slide is the last one
                if (currentSlide === advideos.length - 1) {
                    return;
                }
                $slider.slick('slickNext');
            });
        });
        // AD Product Video Play Pause End
    }


    // AD Product Gallery Slider Start
    if ($(".js-sp-product-gallery-slider").length > 0) {
        $('.js-sp-product-gallery-slider').slick({
            focusOnSelect: true,
            // variableWidth: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            prevArrow: `<button type="button" class="sp-slick-arrow sp-slick-prev slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="sp-slick-arrow sp-slick-next slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.35,
                        infinite: false
                    }
                }
            ]
        });
        // AD Product Gallery Slider End
    }

    preventHyperLinking();

    function UpdateMasterSelectVariant(card, selected_options) {
        let variants_list = card.querySelectorAll('.variants-values li');
        let options_items = card.querySelectorAll('.variant-option-selection');
        let variant_id = '';
        variants_list.forEach((item) => {
            if (item.getAttribute('data-name').trim().includes(selected_options.trim())) {
                // change select element option based on item data-id attribute
                variant_id = item.getAttribute('data-id');
            }
        });
        return variant_id;
    }
    const productCards = document.querySelectorAll('.product-box'); // Replace with your card's class name
    productCards.forEach((card) => {
        const selectElements = card.querySelectorAll('.variant-option-selection');
        selectElements.forEach((select) => {
            select.addEventListener('change', function (event) {
                const parentContent = event.target.closest('.product-box');
                let productId = this.dataset.productid;
                let selectedOptions = '';
                let allSelected = true;
                selectElements.forEach((selects) => {
                    if (selects.value == '') {
                        allSelected = false;
                    } else {
                        selectedOptions += selects.value + ' '
                    }
                });
                let properties = this.dataset.properties;
                const cartButton = card.querySelector('.collection-add-to-cart');
                if (selectedOptions !== '' && allSelected) {
                    let variant_id = UpdateMasterSelectVariant(card, selectedOptions);
                    if (variant_id !== '' && productId != '') {
                        let variantJson = JSON.parse(card.querySelector(".product-" + productId).textContent);
                        let selectedVariantJSON = variantJson.find((variant) => {
                            return variant.id == variant_id
                        });
                        if (selectedVariantJSON) {
                            parentContent.querySelector('.sp-product-card__price-sale.original-price').innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                            parentContent.querySelector('.sp-product-card__price-original.current-price').innerHTML = theme.Currency.formatMoney(selectedVariantJSON.price, theme.settings.moneyFormat)
                            applyDiscountCode(parentContent)
                            if (!selectedVariantJSON.available) {
                                cartButton.classList.add('sold-out-btn')
                                cartButton.setAttribute('disabled', 'disabled')
                                cartButton.innerHTML = cartButton.dataset.soldout;
                            } else {
                                cartButton.classList.remove('sold-out-btn')
                                cartButton.removeAttribute("disabled");
                                cartButton.innerHTML = cartButton.dataset.addtocart;
                            }
                        }
                        cartButton.setAttribute(
                            'onclick',
                            `event.preventDefault();document.querySelector('ajax-cart').addToCartMultiple('${variant_id}',1,{"${properties}":1})`
                        );
                    }
                }
            })
        })
    })

    document.addEventListener("click", (event) => {
        // Check if the clicked element matches the desired class
        if (event.target.classList.contains("search-results__see-all-results")) {
            const inputElement = document.querySelector("#fastSearch");
            if (inputElement) {
                // Dispatch the "keyup" event with Enter key details
                inputElement.dispatchEvent(new KeyboardEvent("keyup", {
                    key: "Enter",
                    keyCode: 13,
                    code: "Enter",
                    which: 13,
                    bubbles: true
                }));
            }
        }
    });

    const subMenuItems = document.querySelectorAll(".js-has-submenu");

    if (subMenuItems) {
        subMenuItems.forEach(function (item, index) {
            item.addEventListener("mouseenter", () => document.body.classList.add("is--active-sp-submenu"));
            item.addEventListener("mouseleave", () => document.body.classList.remove("is--active-sp-submenu"));
        })
    }
    let prodSupport = document.querySelector('.open-support-chat')
    if (prodSupport) {
        prodSupport.addEventListener("click", function (event) {
            event.preventDefault();
            if (window.GorgiasChat) {
                window.GorgiasChat.open()
            }
        })
    }

    if (document.querySelector(".sp-product-page")) {
        const observerRecharge = new MutationObserver(() => {
            const widget = document.querySelector('.recharge-subscription-widget');
            if (widget) {
                setTimeout(function () {
                    const hostElement = document.querySelector('recharge-subscription-widget');
                    if (hostElement) {
                        let shadow_root = hostElement.shadowRoot;
                        if (shadow_root) {
                            const rechargeOption = shadow_root.querySelectorAll('.rc-purchase-option');
                            if (rechargeOption.length > 0) {
                                attachSubscriptionChangeHandlers(rechargeOption)
                            } else {
                                registerSubwidget(shadow_root)
                            }
                        }
                    } else {
                        applyDiscountCodePDP();
                    }
                }, 700)
                observerRecharge.disconnect();
            }
        });
        observerRecharge.observe(document.body, { childList: true });

        function registerSubwidget(shadow_root) {
            if (shadow_root) {
                setTimeout(function () {
                    const rechargeOption = shadow_root.querySelectorAll('.rc-purchase-option');
                    if (rechargeOption.length > 0) {
                        attachSubscriptionChangeHandlers(rechargeOption)
                    }
                }, 200)
            }
        }
        function attachSubscriptionChangeHandlers(rechargeOption) {
            if (rechargeOption.length > 0) {
                // apply here
                applyDiscountCodePDP();
                rechargeOption.forEach(function (element) {
                    element.addEventListener('change', function (event) {
                        applyDiscountCodePDP();
                    });
                });
            }
        }
    }

})

function collectionAjax(load_more_btn) {
    if (load_more_btn) {
        load_more_btn.addEventListener('click', function (e) {
            e.preventDefault();
            let $this = this;
            if ($this.classList.contains("active")) {
                return false;
            }
            $this.classList.add('active');
            let section = document.querySelector('ul#product-grid');
            let collections = document.querySelector('.collection-hero__inner .collections');
            let loader = document.querySelector('.apply-changes .lds-ring');
            document.querySelector('.apply-changes span').style.opacity = "70%";
            section.classList.add('loading');
            if (collections) {
                collections.classList.add('loading'); 
            }
            loader.classList.remove('hidden');
            let link = this.href;
            let isPartFinder = document.querySelector(".sp-collection-part-finder");
            if (isPartFinder) {
                isPartFinder.classList.add('loading');
                if (link.indexOf("view=part-finder") === -1) {
                    if (link.indexOf("?") === -1) {
                        link = link + "?view=part-finder"
                    } else {
                        link = link + "&view=part-finder"
                    }
                }
            } else {
                if (link.indexOf("view=ajax") === -1) {
                    if (link.indexOf("?") === -1) {
                        link = link + "?view=ajax"
                    } else {
                        link = link + "&view=ajax"
                    }
                }
            }

            fetch(link)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = responseText;
                    const parser = new DOMParser();
                    let newDOM = parser.parseFromString(html, "text/html");
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    let par = urlParams.get('discount')
                    let stateObj = { parameter: par }
                    if (link.indexOf("view=ajax") != -1) {
                        link = link.replace('&view=ajax', '')
                        link = link.replace('?view=ajax', '')
                    }
                    window.history.replaceState(stateObj, null, link);
                    loader.classList.add('hidden');
                    document.querySelector('.apply-changes span').style.opacity = "100%";
                    if (load_more_btn.classList.contains('previous')) {
                        section.innerHTML = newDOM.querySelector('ul#product-grid').innerHTML + section.innerHTML;
                    } else {
                        section.innerHTML += newDOM.querySelector('ul#product-grid').innerHTML;
                    }

                    let pagination = newDOM.querySelector('.pagination-list-wrapper').innerHTML;
                    let previousPage = document.querySelector('.pagination-list-wrapper-previous');
                    if (pagination.trim() != '') {
                        if (newDOM.getElementById("load-more-collections-btn") && !load_more_btn.classList.contains('previous')) {
                            load_more_btn.href = newDOM.getElementById("load-more-collections-btn").href;
                        }
                        if (newDOM.getElementById("load-previous-collections-btn")) {
                            if (load_more_btn.classList.contains('previous')) {
                                load_more_btn.href = newDOM.getElementById("load-previous-collections-btn").href;
                            }
                        } else {
                            if (previousPage) {
                                previousPage.style.display = 'none';
                            }
                        }
                        let back_to_top = newDOM.getElementById('back-to-top');
                        if (back_to_top) {
                            load_more_btn.remove();
                            document.querySelector('.pagination-list-wrapper').innerHTML = pagination;
                            back_to_top = document.getElementById('back-to-top');
                            back_to_top.style.display = '';
                            back_to_top.addEventListener("click", () => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth"
                                });
                            });
                        }
                    } else {
                        load_more_btn.remove();
                    }
                    document.dispatchEvent(
                        new CustomEvent("ajaxSearchComplete", {
                            bubbles: true,
                            detail: {},
                        }),
                    );
                    preventHyperLinking();
                    let number_of_products = document.querySelectorAll("[data-productcount]");
                    let number_of_products_newdom = newDOM.querySelector("[data-productcount]");
                    if (number_of_products.length > 0) {
                        let base_count = number_of_products[0].innerHTML;
                        number_of_products.forEach(function (element, index) {
                            if (number_of_products_newdom) {
                                element.innerHTML = parseInt(base_count) + parseInt(number_of_products_newdom.dataset.count);
                            }
                        })
                    }
                    document.querySelectorAll('#product-grid .grid__item .product__card').forEach((card) => {
                        if (!card.querySelector(".discounted")) {
                            applyDiscountCode(card)
                        }

                    });
                    section.classList.remove('loading');
                    const animatedElements = document.querySelectorAll('.fade-in-animation');
                    animatedElements.forEach(element => {
                        element.classList.add('visible');
                    });
                    if (collections) {
                        collections.classList.remove('loading');
                    }
                    $this.classList.remove('active');
                    if (isPartFinder) {
                        isPartFinder.classList.remove('loading');
                    }
                });
        })
    }
}

function extractAnswers() {
    const inputs = document.querySelectorAll('.input-wrapper input[type="radio"]');
    const questions = {};
    inputs.forEach(input => {
        const handle = input.getAttribute('data-handle'); // Extract handle
        const group = input.getAttribute('data-group');   // Extract group
        const value = input.value;                        // Extract point (value)
        const name = input.name;                          // Extract question name
        // Initialize the question if it doesn't exist
        if (!questions[name]) {
            questions[name] = {};
            questions[name]['priority'] = input.getAttribute('data-priority');
        }
        // Add the handle as a sub-item with group and point
        questions[name][handle] = {
            group: group,
            point: parseInt(value, 10) // Convert value to integer
        };
    });
    return questions;
}

function getCheckedRadioValues(formSelector) {
    const form = document.querySelector(formSelector);
    const checkedValues = {}

    form.querySelectorAll('input[type="radio"]:checked').forEach(input => {
        checkedValues[input.name] = input.getAttribute('data-handle');
    });

    return checkedValues;
}

function calculateWidth() {
    const steps = document.querySelectorAll(".step");
    const completedSteps = document.querySelectorAll(".step.complete");
    const progressBar = document.querySelector(".completed_progress");
    if (steps.length === 0) return;

    // Calculate progress percentage
    const progress = Math.max(0, Math.min(100, (completedSteps.length / (steps.length - 1)) * 100));
    // Update the progress bar width
    progressBar.style.width = progress + "%";
}
function updateRechargeWidgetPrice(new_price, updatePrice = true) {
    if (!updatePrice) {
        return;
    }
    const hostElement = document.querySelector('recharge-subscription-widget');
    if (hostElement) {
        let shadow_root = hostElement.shadowRoot;
        if (shadow_root) {
            let subscrition = shadow_root.querySelector('.rc-purchase-option.rc-purchase-option__subscription');
            if (subscrition) {
            // subscrition.hasAttribute('rc-not-selected')
                const priceElement = shadow_root.querySelector('.rc-selection__onetime .rc-purchase-option__prices>span.rc-price');
                if (priceElement) {
                    setTimeout(function () {
                        priceElement.textContent = new_price.trim();
                    }, 800)
                }
            }
        }
    }
}

function updateURLParams(param, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value); // Set or update the parameter
    window.history.pushState({ path: url.href }, "", url.href);
}

function doesSubscriptionSelected() {
    const result = { subscription: false, amount: 15 };
    const hostElement = document.querySelector('recharge-subscription-widget');
    console.log(hostElement)
    if (!hostElement || !hostElement.shadowRoot) return result;

    const shadowRoot = hostElement.shadowRoot;
    const subscriptionElement = shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

    if (!subscriptionElement) return result;

    const originalPriceElement = shadowRoot.querySelector(".rc-price.strike-through");
    const salePriceElement = shadowRoot.querySelector(".rc-price:not(.strike-through)");

    if (originalPriceElement && salePriceElement) {
        const originalPrice = parseFloat(originalPriceElement.textContent.replace(/[^0-9.]/g, ""));
        const salePrice = parseFloat(salePriceElement.textContent.replace(/[^0-9.]/g, ""));

        if (!isNaN(originalPrice) && !isNaN(salePrice) && originalPrice > salePrice) {
            result.amount = (((originalPrice - salePrice) / originalPrice) * 100).toFixed(2);
        }
    }

    result.subscription = !subscriptionElement.hasAttribute('rc-not-selected');
    return result;
}